var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiChatGlow = function SvgAiChatGlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-135.5 0 1328 763"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-chat-glow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7792FF",
    fillOpacity: 0.9,
    d: "M528.5 254c0 298.822 365.112 580.935 815.5 580.935-450.388 0-815.5 242.245-815.5 541.065 0-298.82-365.112-541.065-815.5-541.065 450.388 0 815.5-282.113 815.5-580.935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ai-chat-glow_svg__a",
    width: 2139,
    height: 1630,
    x: -541,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_213_201839",
    stdDeviation: 127
  })))));
};
export default SvgAiChatGlow;